import React, { useState, useEffect} from "react";
import { observer } from "mobx-react";

const PermittedItem = ({ title, notes }) => {
    return (
        <span className="list-group-item list-group-item-action d-flex justify-content-between">
            <div className="li-wrapper d-flex justify-content-start align-items-center">
                <div className="list-content">
                    <h6 className="mb-1">{title}</h6>
                    {notes?.length ? (<small className="text-muted">{notes}</small>) : (<></>)}
                </div>
            </div>
        </span>
    );
};

const PermittedItems = observer((props) => {
    const [itemCount, setItemCount] = useState(0);

 

    useEffect(() => {
        let count = 0;
        if (props?.examConfiguration?.permittedBathroomBreak) count++;
        if (props?.examConfiguration?.permittedBlankPaper) count++;
        if (props?.examConfiguration?.permittedCalculator) count++;
        if (props?.examConfiguration?.permittedDictionary) count++;
        if (props?.examConfiguration?.permittedEarplugs) count++;
        if (props?.examConfiguration?.permittedFormulaSheet) count++;
        if (props?.examConfiguration?.permittedNotes) count++;
        if (props?.examConfiguration?.permittedTextbook) count++;
        if (props?.examConfiguration?.permittedWebsites) count++;
        if (props?.examConfiguration?.permittedOtherItems) count++;
        setItemCount(count);
    }, [props.examConfiguration]);

    return (
        <>
            <div className="list-group">
                {props?.examConfiguration?.permittedBathroomBreak && (
                    <PermittedItem title="Bathroom Break" notes={props.examConfiguration?.permittedBathroomBreakInformation} />
                )}
                {props?.examConfiguration?.permittedBlankPaper && (
                    <PermittedItem title="Blank Paper" notes={props.examConfiguration?.permittedBlankPaperInformation} />
                )}
                {props?.examConfiguration?.permittedCalculator && (
                    <PermittedItem title="Calculator" notes={props.examConfiguration?.permittedCalculatorInformation} />
                )}
                {props?.examConfiguration?.permittedDictionary && (
                    <PermittedItem title="Dictionary" notes={props.examConfiguration?.permittedDictionaryInformation} />
                )}
                {props?.examConfiguration?.permittedEarplugs && (
                    <PermittedItem title="Earplugs" notes={props.examConfiguration?.permittedEarplugsInformation} />
                )}
                {props?.examConfiguration?.permittedFormulaSheet && (
                    <PermittedItem title="Formula Sheet" notes={props.examConfiguration?.permittedFormulaSheetInformation} />
                )}
                {props?.examConfiguration?.permittedNotes && (
                    <PermittedItem title="Notes" notes={props.examConfiguration?.permittedNotesInformation} />
                )}
                {props?.examConfiguration?.permittedTextbook && (
                    <PermittedItem title="Textbook" notes={props.examConfiguration?.permittedTextbookInformation} />
                )}
                {props?.examConfiguration?.permittedWebsites && (
                    <PermittedItem title="Websites" notes={props.examConfiguration?.permittedWebsitesInformation} />
                )}
                {props?.examConfiguration?.permittedOtherItems && (
                    <PermittedItem title="Other Items" notes={props.examConfiguration?.permittedOtherItems} />
                )}
            </div>
            {itemCount === 0 && <div>No additional items permitted.</div>}
        </>
    );
});

export default PermittedItems;

